export const SUBSCRIPTION_TIER_MAP: Record<
  SubscriptionTierAlias,
  SubscriptionTier
> = {
  free: 0,
  plus: 1,
};
